// extracted by mini-css-extract-plugin
module.exports = {"container":"DateRangePicker_container__3v58q","selectContainer":"DateRangePicker_selectContainer__1xr-F","label":"DateRangePicker_label__1-MaG"};